"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ArrowDropLeft3_exports = {};
__export(ArrowDropLeft3_exports, {
  default: () => ArrowDropLeft3_default
});
module.exports = __toCommonJS(ArrowDropLeft3_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.37109 16.9102C3.31901 16.8971 3.26693 16.8776 3.21484 16.8516C3.16276 16.8125 3.1237 16.7669 3.09766 16.7148C3.05859 16.6628 3.03255 16.6107 3.01953 16.5586C3.00651 16.5065 3 16.4479 3 16.3828C3 14.9115 3.1888 13.5703 3.56641 12.3594C3.94401 11.1484 4.49089 10.0938 5.20703 9.19531C5.92318 8.29688 6.79557 7.56771 7.82422 7.00781C8.83984 6.44792 9.9987 6.08333 11.3008 5.91406V3.27734C11.3008 3.22526 11.3073 3.17318 11.3203 3.12109C11.3333 3.06901 11.3594 3.02344 11.3984 2.98438C11.4245 2.94531 11.457 2.91276 11.4961 2.88672C11.5352 2.84766 11.5807 2.8151 11.6328 2.78906C11.6719 2.77604 11.7174 2.76953 11.7695 2.76953C11.8216 2.75651 11.8737 2.75 11.9258 2.75C11.9779 2.76302 12.0234 2.78255 12.0625 2.80859C12.1146 2.83464 12.1602 2.86719 12.1992 2.90625L17.8438 8.64844C17.8958 8.6875 17.9349 8.73958 17.9609 8.80469C17.987 8.86979 18 8.94141 18 9.01953C18 9.08464 17.987 9.14974 17.9609 9.21484C17.9349 9.27995 17.8958 9.33854 17.8438 9.39062L12.1992 15.1328C12.1602 15.1589 12.1146 15.1849 12.0625 15.2109C12.0234 15.237 11.9779 15.2565 11.9258 15.2695C11.8737 15.2826 11.8216 15.2891 11.7695 15.2891C11.7174 15.276 11.6719 15.2565 11.6328 15.2305C11.5807 15.2174 11.5352 15.1979 11.4961 15.1719C11.457 15.1328 11.4245 15.0872 11.3984 15.0352C11.3594 14.9961 11.3333 14.957 11.3203 14.918C11.3073 14.8659 11.3008 14.8138 11.3008 14.7617V12.1641C11.1315 12.1771 10.9622 12.1901 10.793 12.2031C10.6237 12.2161 10.4609 12.2357 10.3047 12.2617C9.65365 12.3659 9.03516 12.5286 8.44922 12.75C7.86328 12.9714 7.30339 13.2643 6.76953 13.6289C6.2487 13.9935 5.75391 14.4297 5.28516 14.9375C4.81641 15.4453 4.3737 16.0182 3.95703 16.6562C3.90495 16.7344 3.83984 16.7995 3.76172 16.8516C3.68359 16.8906 3.60547 16.9102 3.52734 16.9102C3.5013 16.9102 3.47526 16.9102 3.44922 16.9102C3.42318 16.9102 3.39714 16.9102 3.37109 16.9102ZM12.2969 4.44922V6.79297L11.4375 6.89062C10.2526 7.04688 9.20443 7.37891 8.29297 7.88672C7.38151 8.38151 6.61328 9.01953 5.98828 9.80078C5.48047 10.4388 5.0638 11.1745 4.73828 12.0078C4.41276 12.8411 4.19792 13.7721 4.09375 14.8008C4.5625 14.2279 5.0638 13.7266 5.59766 13.2969C6.11849 12.8542 6.67188 12.4831 7.25781 12.1836C7.85677 11.8841 8.48828 11.6497 9.15234 11.4805C9.81641 11.3112 10.5195 11.207 11.2617 11.168L12.2969 11.1289V13.5898L16.8086 9.01953L12.2969 4.44922Z",
      fill: "currentColor"
    }
  )
);
const SvgArrowDropLeft3 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ArrowDropLeft3_default = SvgArrowDropLeft3;
